import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cn from 'clsx';
import { useDeviceType, UIText1 } from '@cian/ui-kit';
import { CheckMark } from '../CheckMark';
import { EFieldSubType } from '../../../../constants/fieldSubtype';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Card = function Card(props) {
  var _cn;
  var selected = props.selected,
    value = props.value,
    label = props.label,
    imageUrl = props.imageUrl,
    iconType = props.iconType,
    onClick = props.onClick,
    selectable = props.selectable,
    active = props.active;
  var deviceType = useDeviceType();
  var handleClick = React.useCallback(function () {
    return onClick(value);
  }, [onClick, value]);
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles['card'], (_cn = {}, _defineProperty(_cn, styles['card_mobile'], deviceType === 'phone'), _defineProperty(_cn, styles['card_icon'], iconType === EFieldSubType.Icon), _defineProperty(_cn, styles['card_pic'], iconType === EFieldSubType.Pictures), _defineProperty(_cn, styles['card_layout'], iconType === EFieldSubType.Layout), _defineProperty(_cn, styles['active'], active), _cn)),
    onClick: handleClick,
    "data-testid": "card",
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      children: [/*#__PURE__*/_jsx(UIText1, {
        display: "inline",
        children: label
      }), selectable && /*#__PURE__*/_jsx("div", {
        className: styles['checkmark'],
        children: /*#__PURE__*/_jsx(CheckMark, {
          checked: !!selected
        })
      })]
    }), imageUrl && /*#__PURE__*/_jsx("div", {
      className: styles['image-container'],
      children: /*#__PURE__*/_jsx("img", {
        className: styles['image'],
        src: imageUrl
      })
    })]
  });
};
Card.displayName = 'Card';